import React, { useState } from "react";
import { useAppServices } from "../../../../../../hook/services";
import { toast } from "react-toastify";

const Others = ({ app, handleRefresh }) => {
  const AppService = useAppServices();
  const [formData, setFormData] = useState({
    funKey: app?.funKey || "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = { _id: app._id, ...formData };

      const { response, error } = await AppService.apps.update({ payload });

      if (response) {
        toast.success("Settings updated successfully!");
        handleRefresh?.();
      } else {
        throw new Error(error?.message || "Failed to update");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white shadow-sm rounded-4 p-4">
      <div className="mb-4 border-bottom pb-2 d-flex justify-content-between align-items-center">
        <h5 className="fw-bold mb-0">Other Settings</h5>
      </div>

      <form onSubmit={handleSubmit} className="row g-4">
        {/* Field: FunKey */}
        <div className="col-md-6">
          <label className="form-label fw-semibold">
            Conversation Provider Function Key
          </label>
          <input
            type="text"
            className="form-control rounded-3 shadow-sm"
            name="funKey"
            value={formData.funKey}
            onChange={handleChange}
            placeholder="Enter function key"
            required
          />
        </div>

        {/* Actions */}
        <div className="col-12 d-flex justify-content-end mt-3">
          <button
            type="submit"
            className="btn btn-success px-4 py-2 rounded-3 shadow-sm"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Others;
